import { render, staticRenderFns } from "./vendor-po.vue?vue&type=template&id=2e3374b1&"
import script from "./vendor-po.vue?vue&type=script&lang=js&"
export * from "./vendor-po.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports